import { Box, styled, Typography } from '@mui/material';
import { StaticDatePicker } from '@mui/x-date-pickers';

export const ShareDateLabel = styled(Typography)({
    fontSize: '17px',
    fontWeight: 600,
    lineHeight: 'normal',
});

export const ShareDateBox = styled(Box)({
    borderRadius: '12px',
    height: 'fit-content',
    background:
        'linear-gradient(171deg, rgba(58, 98, 227, 0.18) 0%, rgba(89, 184, 202, 0.18) 100%)',
    boxShadow: '9px 8px 41px 0px rgba(0, 0, 0, 0.59)',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
});

export const ShareDatePicker = styled(StaticDatePicker)(({ theme }) => ({
    '&.MuiPickersLayout-root': {
        minWidth: 290,
    },
    '& .MuiDialogActions-root': {
        display: 'none',
    },
    '& .MuiPickersLayout-contentWrapper': {
        gridColumn: '2 / 4',
    },
    '& .MuiTypography-root, & .MuiButtonBase-root, & .MuiPickersCalendarHeader-label, & .MuiPickersYear-yearButton':
        {
            color: theme.palette.info.main,
        },
    '& .MuiButtonBase-root.Mui-disabled': {
        color: theme.palette.primary.light,
    },
    '& .MuiButtonBase-root.Mui-selected, & .MuiButtonBase-root.Mui-selected:focus , & .MuiPickersYear-yearButton.Mui-selected':
        {
            backgroundColor: theme.palette.primary.main,
        },
    '& .MuiPickersToolbar-root': {
        marginBottom: '10px',
    },
    '& .MuiDateCalendar-root': {
        width: '100%',
        minWidth: '100%',
    },
    '& .MuiPickersToolbar-root, & .MuiDateCalendar-root': {
        backgroundColor: theme.palette.text.primary,
        borderBottom: `2px solid ${theme.palette.success.main}`,
        borderRadius: '2px 2px 0px 0px',
    },
    '& .MuiPickersDay-today': {
        border: `1px solid ${theme.palette.primary.main}`,
    },
    background: 'transparent',
}));
